export const HOMEMATCH_TINDER_DETAILS_CONTENT = {
    CLOSE_BUTTON: "Zamknij",
    getOfferCounterLabel: (position: number, total: number) => `Oferta ${position}/${total}`,
    PROPERTY_LOAD_ERROR: "Wystąpił błąd podczas ładowania nieruchomości. Spróbuj ponownie później."
} as const;
export const HOMEMATCH_TINDER_DETAILS_CONTENT = {
    CLOSE_BUTTON: "Zamknij",
    getOfferCounterLabel: (position: number, total: number) => `Oferta ${position}/${total}`,
    PROPERTY_LOAD_ERROR: "Wystąpił błąd podczas ładowania nieruchomości. Spróbuj ponownie później."
} as const;
